import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import "./DeletePerson.css";

function DeletePerson() {
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { pid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.user.firstName + " " + response.data.user.lastName);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/people");
    } catch (error) {
      toast(error.response.data.message);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-person">
            <Col>
              <h4>{t("Personas.Persona.DeletePerson.Titulo")}</h4>
            </Col>
            <ToastContainer />
            <Col className="delete-person-form">
              <Col className="mb-1">
                <p>{t("Personas.Persona.DeletePerson.Pregunta")}</p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Personas.Persona.DeletePerson.Eliminar")}
                </Button>
                <Button className="danger" onClick={() => navigate("/people")}>
                  {t("Personas.Persona.DeletePerson.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeletePerson;
